import { Box, Flex, Grid, Text, Spinner, Dialog, Table, Button, Badge, Card, ScrollArea, VisuallyHidden } from '@radix-ui/themes'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import api from '../../api'
import SchoolStaff from '../../components/school/SchoolStaff'
import { staffService } from '../../services/staffService'
import { verificationService } from '../../services/verificationService'
import { VerticalProfileSkeleton } from '../../components/skeletons/Skeletons'
import UserAvatar from '../../components/common/UserAvatar'
import { STATUS_COLORS } from '../../utils/constants'
import LoadingIndicator from '../../components/shared/LoadingIndicator'
import { CheckIcon, Cross2Icon } from '@radix-ui/react-icons'
import SchoolTeacherSummaryView from '../../components/school/SchoolTeacherSummaryView'
import SchoolTeacherView from './SchoolTeacherView'
import SchoolVerifications from './SchoolVerifications'
import MessageBox from '../../components/common/MessageBox'
// import { ConfirmDialog } from '../../components/common/ConfirmDialog'
// import { Avatar } from '@radix-ui/themes'

const SchoolTeachers = () => {
    // const accountDetails = useSelector((state) => state.user.accountDetails);
    // const [teachers, setTeachers] = useState([]);
    const teachers = useSelector((state) => state.schoolAdmin.teachers);
    // console.log('teachers--------------', teachers);
    const [selectedTeacher, setSelectedTeacher] = useState(null);
    // const [showDetails, setShowDetails] = useState(false);
    const [verifications, setVerifications] = useState([]);
    // const [pendingVerifications, setPendingVerifications] = useState([]);
    // const [approvedVerifications, setApprovedVerifications] = useState([]);
    const [loading, setLoading] = useState({});
    // const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const school = useSelector((state) => state.schoolAdmin.school);


    const fetchVerifications = async () => {
        setLoading({ type: 'page' });
        try {
            const verifications = await staffService.getAllVerifications(school.id);
            console.log('verifications', verifications);
            setVerifications(verifications);
            // setPendingVerifications(verifications.filter(verification => verification.status === 'pending'));
            // setApprovedVerifications(verifications.filter(verification => verification.status === 'approved'));
            // setShowDetails(true);
        } catch (error) {
            console.error('Error fetching staff:', error);
        } finally {
            setLoading(null);
        }
    }

    const getStaff = async () => {
        setLoading({ type: 'fetch' });
        try {
            const data = await staffService.getStaff();
            console.log('STAFF Data', data);
            setTeachers(data);
        } catch (error) {
            console.error('Error fetching staff:', error);
        } finally {
            setLoading(null);
        }
    }

    useEffect(() => {
        console.log('loading', loading);
    }, [loading]);

    const handleVerificationSelect = async (verification) => {
        try {
            setLoading({ type: 'fetch', id: verification.verification_id });
            const data = await verificationService.getVerificationDetails(verification.verification_id);
            setSelectedTeacher(data.verification);
        } catch (error) {
            console.error('Error fetching staff details:', error);
        } finally {
            setLoading(null);
        }
    }



    const handleSelectTeacher = (teacher) => {
        console.log('teacher', teacher);
        setSelectedTeacher(teacher);
    }

    const closeDetails = () => {
        setSelectedTeacher(null);
    }

    if (loading?.type === 'page') {
        return <LoadingIndicator />
    }

    return (
        <Box width="100%" maxWidth="1080px">


            {teachers.length < 1 ? (
                <MessageBox type="warning" title="No Teachers" message="We cannot find any verification sent to this account. Remind your teachers to register on edusua.com" />
            ) : (
                <Grid>
                    <ScrollArea type="scroll" scrollbars="horizontal">
                        <Flex gap="4" p="2" width={teachers.length * 140}>
                            {teachers.map((teacher) => (
                                <Card
                                    key={teacher.id}
                                    style={{
                                        cursor: 'pointer',
                                        width: '120px',
                                        height: '140px',
                                        flexShrink: 0
                                    }}
                                    onClick={() => handleSelectTeacher(teacher)}
                                >
                                    <Flex direction="column" justify="center" gap="1" align="center" p="2">
                                        <UserAvatar size="4" user={teacher.user} />
                                        <Text size="1" weight="bold" align="center">{teacher.user.firstname} {teacher.user.lastname}</Text>
                                        <Badge color={STATUS_COLORS[teacher.verification_status]} size="1" variant="soft">{teacher.verification_status}</Badge>
                                        {/* {selectedSubscription?.id === subscription.id && <ChevronDownIcon />} */}
                                    </Flex>
                                </Card>
                            ))}
                        </Flex>
                    </ScrollArea>
                </Grid>
            )}

            {selectedTeacher && (<SchoolTeacherView teacherData={selectedTeacher} />)}
        </Box>
    )
}

export default SchoolTeachers
